import Workspace from "../../../../workspace/Workspace"
import { HackleUser, InAppMessage } from "../../../../model/model"
import { InAppMessageEvaluatorRequest } from "../InAppMessageEvaluatorRequest"

export class InAppMessageEligibilityRequest extends InAppMessageEvaluatorRequest {
  constructor(
    readonly workspace: Workspace,
    readonly user: HackleUser,
    readonly inAppMessage: InAppMessage,
    readonly timestamp: number
  ) {
    super()
  }

  toString(): string {
    return `InAppMessageEligibilityRequest(type=${this.key.type}, key=${this.inAppMessage.key})`
  }
}
